// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"pn_a bic_sn bic_sv bic_sw bic_kx bic_ky bic_ke undefined bic_vt"};